import { Component, EventEmitter, Output, signal } from '@angular/core';

/**
 * Privacy Policy + Terms of Agreement, shown from the footer link.
 * The copy reflects what the application actually does; update it when
 * data-handling behavior changes (new providers, new stored data, etc.).
 */
@Component({
  selector: 'app-legal-modal',
  templateUrl: './legal-modal.html'
})
export class LegalModalComponent {
  @Output() close = new EventEmitter<void>();

  readonly section = signal<'privacy' | 'terms'>('privacy');
  readonly lastUpdated = 'July 4, 2026';
}
